// marks.tsx — Garage mark set, lifted VERBATIM from the Claude Design delivery
// (project f354caf3, identity "the gauge, honestly read").
//
// 🔴 Rendered as INLINE <svg>, never <img src={...}>: an SVG using currentColor inside an
// <img> document resolves to BLACK and vanishes on the dark ground (it shipped Study broken
// 2026-08-06). Inline, currentColor inherits the CSS color.
//
// ⚠️ `kind` on a Service row is FREE TEXT the user typed, so resolution is fuzzy and there is
// an explicit fallback — never an empty box.
import React from "react";

type Geo = { vb: string; el: React.ReactNode };

const SERVICE_ART: Record<string, Geo> = {
  "oil": { vb: "0 0 24 24", el: (<><path d="M12 3c4 5 6.5 8.5 6.5 12a6.5 6.5 0 1 1-13 0c0-3.5 2.5-7 6.5-12z"></path></>) },
  "tyres": { vb: "0 0 24 24", el: (<><circle cx="12" cy="12" r="8.2"></circle><circle cx="12" cy="12" r="2.4" fill="#d6336c" stroke="none"></circle><line x1="12" y1="2.3" x2="12" y2="5.3"></line><line x1="12" y1="18.7" x2="12" y2="21.7"></line><line x1="2.3" y1="12" x2="5.3" y2="12"></line><line x1="18.7" y1="12" x2="21.7" y2="12"></line></>) },
  "brakes": { vb: "0 0 24 24", el: (<><circle cx="12" cy="12" r="7.6"></circle><circle cx="12" cy="8.4" r="0.9" fill="#d6336c" stroke="none"></circle><circle cx="8.6" cy="14.2" r="0.9" fill="#d6336c" stroke="none"></circle><circle cx="15.4" cy="14.2" r="0.9" fill="#d6336c" stroke="none"></circle><path d="M18 8a7.6 7.6 0 0 1 1.5 6.6" strokeWidth="3" strokeLinecap="round"></path></>) },
  "battery": { vb: "0 0 24 24", el: (<><rect x="4" y="8" width="14" height="10" rx="1.6"></rect><rect x="18" y="11" width="2.2" height="4" rx="0.6" fill="#d6336c" stroke="none"></rect><line x1="8.5" y1="11" x2="8.5" y2="15"></line><line x1="6.5" y1="13" x2="10.5" y2="13"></line><line x1="13.5" y1="13" x2="16.5" y2="13"></line></>) },
  "filters": { vb: "0 0 24 24", el: (<><rect x="6" y="3.5" width="12" height="17" rx="3"></rect><line x1="8.5" y1="8" x2="15.5" y2="8"></line><line x1="8.5" y1="11.3" x2="15.5" y2="11.3"></line><line x1="8.5" y1="14.6" x2="15.5" y2="14.6"></line><line x1="8.5" y1="17.9" x2="15.5" y2="17.9"></line></>) },
  "coolant": { vb: "0 0 24 24", el: (<><rect x="4" y="5" width="16" height="14" rx="2.5"></rect><path d="M6.5 12c1.2-1.4 2.4-1.4 3.6 0s2.4 1.4 3.6 0 2.4-1.4 3.6 0"></path><path d="M6.5 15.5c1.2-1.4 2.4-1.4 3.6 0s2.4 1.4 3.6 0 2.4-1.4 3.6 0"></path></>) },
  "inspection": { vb: "0 0 24 24", el: (<><path d="M12 3l6.5 2.4v5.6c0 4.6-2.9 7.9-6.5 9.4-3.6-1.5-6.5-4.8-6.5-9.4V5.4L12 3z"></path><path d="M8.8 12.2l2 2.1 4.4-4.6" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path></>) },
  "other": { vb: "0 0 24 24", el: (<><rect x="7" y="7" width="10" height="10" rx="2" transform="rotate(45 12 12)"></rect><circle cx="12" cy="12" r="1.4" fill="#d6336c" stroke="none"></circle></>) },
};

const UTIL_ART: Record<string, Geo> = {
  "fuel": { vb: "0 0 24 24", el: (<><path d="M4 21h9"></path><path d="M6.5 21V6.5A1.5 1.5 0 0 1 8 5h3a1.5 1.5 0 0 1 1.5 1.5V21"></path><path d="M12.5 9.5H15a1.5 1.5 0 0 1 1.5 1.5v5.3a1.3 1.3 0 0 0 2.6 0V8.2l-2.3-2.3"></path></>) },
  "distance": { vb: "0 0 24 24", el: (<><circle cx="12" cy="12" r="8.5"></circle><line x1="12" y1="12" x2="12" y2="6.2" strokeLinecap="round" transform="rotate(35 12 12)"></line><circle cx="12" cy="12" r="1.1" fill="#d6336c" stroke="none"></circle></>) },
  "cost": { vb: "0 0 24 24", el: (<><circle cx="12" cy="12" r="8"></circle><line x1="7.5" y1="12" x2="16.5" y2="12"></line><line x1="12" y1="9" x2="12" y2="15"></line></>) },
  "empty-garage": { vb: "0 0 64 64", el: (<><line x1="16" y1="10" x2="16" y2="54"></line><line x1="48" y1="10" x2="48" y2="54"></line><line x1="32" y1="10" x2="32" y2="54" strokeDasharray="4 5"></line><circle cx="32" cy="32" r="3" fill="#d6336c" stroke="none"></circle></>) },
  "first-fillup": { vb: "0 0 64 64", el: (<><line x1="13.6" y1="16.6" x2="9.8" y2="13.4" stroke="rgba(214,51,106,0.38)" strokeWidth="2.4"></line>
<line x1="20.0" y1="11.2" x2="17.5" y2="6.9" stroke="rgba(214,51,106,0.38)" strokeWidth="2.4"></line>
<line x1="27.8" y1="8.4" x2="27.0" y2="3.4" stroke="rgba(214,51,106,0.38)" strokeWidth="2.4"></line>
<line x1="36.2" y1="8.4" x2="37.0" y2="3.4" stroke="rgba(214,51,106,0.38)" strokeWidth="2.4"></line>
<line x1="44.0" y1="11.2" x2="46.5" y2="6.9" stroke="rgba(214,51,106,0.38)" strokeWidth="2.4"></line>
<line x1="50.4" y1="16.6" x2="54.2" y2="13.4" stroke="rgba(214,51,106,0.38)" strokeWidth="2.4"></line>
<line x1="54.6" y1="23.8" x2="59.3" y2="22.1" stroke="rgba(214,51,106,0.38)" strokeWidth="2.4"></line>
<line x1="56.0" y1="32.0" x2="61.0" y2="32.0" stroke="rgba(214,51,106,0.38)" strokeWidth="2.4"></line>
<line x1="54.6" y1="40.2" x2="59.3" y2="41.9" stroke="rgba(214,51,106,0.38)" strokeWidth="2.4"></line>
<line x1="32" y1="32" x2="32" y2="14" strokeWidth="2.4" strokeLinecap="round" transform="rotate(-70 32 32)"></line><circle cx="32" cy="32" r="2.6" fill="#d6336c" stroke="none"></circle></>) },
};

function Svg({ geo, className, title, size }:
  { geo: Geo; className?: string; title?: string; size?: number }) {
  return (
    <svg viewBox={geo.vb} width={size} height={size} className={className}
         role={title ? "img" : "presentation"} aria-label={title}
         aria-hidden={title ? undefined : true} focusable="false">
      {title ? <title>{title}</title> : null}
      {geo.el}
    </svg>
  );
}

/** Free-text service kinds → art. Matched loosely because the user types this field.
 *  Anything unmatched resolves to "other" — the delivery's stated fallback. */
const KIND_PATTERNS: [RegExp, string][] = [
  [/oil|lube|sump/i, "oil"],
  [/tyre|tire|wheel|puncture|track|align/i, "tyres"],
  [/brake|disc|pad|caliper/i, "brakes"],
  [/batter|altern|starter|electric/i, "battery"],
  [/filter|air|cabin|pollen|fuel filter/i, "filters"],
  [/coolant|antifreeze|radiator|water pump|thermostat/i, "coolant"],
  [/mot|inspect|service|check|valet|test/i, "inspection"],
];
export function resolveServiceKind(kind: string): string {
  const k = (kind || "").trim();
  for (const [re, id] of KIND_PATTERNS) if (re.test(k)) return id;
  return "other";
}

export function ServiceMark({ kind, className = "mark", size, title }:
  { kind: string; className?: string; size?: number; title?: string }) {
  const id = resolveServiceKind(kind);
  return <Svg geo={SERVICE_ART[id]} className={className} size={size} title={title ?? kind} />;
}

export function UtilMark({ id, className = "mark", size, title }:
  { id: "fuel" | "distance" | "cost" | "empty-garage" | "first-fillup";
    className?: string; size?: number; title?: string }) {
  return <Svg geo={UTIL_ART[id]} className={className} size={size} title={title} />;
}

/** For the P7 coverage assertion: every key the code can resolve to. */
export const SERVICE_KEYS = Object.keys(SERVICE_ART);
export const UTIL_KEYS = Object.keys(UTIL_ART);
